import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";
import { Platform } from "@src/mobile/utils/platform";

export function useScheduleTabEnabled(): boolean {
  const isRedesignEnabled = useIsRedesignEnabled();
  const isScheduleTabFlagEnabled = useCbhFlag(CbhFeatureFlag.SCHEDULE_TAB_ENABLED, {
    defaultValue: true,
  });

  return isRedesignEnabled && (Platform.isMobile || isScheduleTabFlagEnabled);
}
